// extracted by mini-css-extract-plugin
export default {"intro":"ModalNuevoPago_intro__MBDHu","input":"ModalNuevoPago_input__+3q+Q"};